
/* eslint-disable */ 
const path = require('path')
// const TerserPlugin = require('terser-webpack-plugin')
const fs = require('fs');
module.exports = {
  devServer: {
    disableHostCheck: true,
    // https: true
    // {
      // key: fs.readFileSync(path.resolve(__dirname, 'cert/server.key')),
      // cert: fs.readFileSync(path.resolve(__dirname,'cert/server.cert')),
    // }
  },
  configureWebpack: {
    resolve: {
      alias: {
        namisconfig: process.env.NODE_ENV === 'production' ? path.resolve(__dirname, 'src/config/namis-prod.js') : path.resolve(__dirname, 'src/config/namis-dev.js'),
        appconfig: process.env.NODE_ENV === 'production' ? path.resolve(__dirname, 'src/config/prod.js') : path.resolve(__dirname, 'src/config/dev.js'),
        command: path.resolve(__dirname, 'src/plugins/Command'),
        src: path.resolve(__dirname, 'src/'),
        NafComponents: path.resolve(__dirname, 'src/components'),
        'naf-acl': path.resolve(__dirname, 'src/modules/acl/index.js'),
        'utils': path.resolve(__dirname, 'src/plugins/Utils'),
      },
    },
    externals: [
      {
        './cptable': 'var cptable',
        '../xlsx.js': 'var _XLSX'
      }
    ]
    // optimization: {
    //   minimizer: process.env.NODE_ENV === 'production' ? [
    //     new TerserPlugin({
    //       sourceMap: true,
    //       terserOptions: {
    //         compress: {
    //           drop_console: true
    //         }
    //       }
    //     })
    //   ] : []
    // },
  },
  pwa: {
    themeColor: '#ffffff',
    workboxPluginMode: 'InjectManifest',
    workboxOptions: {
      swSrc: 'src/service-worker.js'
    }
  },
  pluginOptions: {
    quasar: {
      rtlSupport: true,
      importAll: true,
      treeShake: true
    }
  },
  transpileDependencies: [
    /[\\/]node_modules[\\/]quasar[\\/]/
  ]
}
